import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export function isBrowseV2Enabled() {
  return GrowthDiscoveryEpicClient.get('enableBrowseV2');
}

export function previewBrowseV2() {
  return GrowthDiscoveryEpicClient.preview('enableBrowseV2');
}

export function isBrowseSkillsEnabled() {
  return GrowthDiscoveryEpicClient.get('enableBrowseSkillPages');
}

export function previewBrowseSkillsV2() {
  return GrowthDiscoveryEpicClient.preview('enableBrowseSkillPages');
}
